// src/components/Layout.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";

function Layout({ children }) {
    const [isOpen, setIsOpen] = useState(true);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="flex min-h-screen">
            <div
                className={`bg-gray-800 text-white transition-all duration-300
          ${isOpen ? "w-64" : "w-16"}
        `}>
                <div className="flex items-center justify-between p-4">
                    <span
                        className={`text-lg font-bold ${!isOpen && "hidden"}`}>
                        WeKruit
                    </span>
                    <button
                        onClick={toggleSidebar}
                        className="bg-gray-700 rounded p-1 ml-auto">
                        {isOpen ? "<" : ">"}
                    </button>
                </div>

                {/* Navigation Links */}
                <nav className="mt-4">
                    <ul>
                        {/* Overview */}
                        <li className="mb-2">
                            <Link
                                to="/"
                                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-700">
                                <span className="material-icons">
                                    dashboard
                                </span>
                                {isOpen && <span>Overview</span>}
                            </Link>
                        </li>

                        {/* Cases */}
                        <li className="mb-2">
                            <Link
                                to="/cases"
                                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-700">
                                <span className="material-icons">folder</span>
                                {isOpen && <span>Cases</span>}
                            </Link>
                        </li>

                        {/* Users */}
                        <li className="mb-2">
                            <Link
                                to="/users"
                                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-700">
                                <span className="material-icons">group</span>
                                {isOpen && <span>Users</span>}
                            </Link>
                        </li>

                        {/* Feedback */}
                        <li className="mb-2">
                            <Link
                                to="/feedback"
                                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-700">
                                <span className="material-icons">feedback</span>
                                {isOpen && <span>Feedback</span>}
                            </Link>
                        </li>

                        {/* Email */}
                        <li className="mb-2">
                            <Link
                                to="/email"
                                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-700">
                                <span className="material-icons">email</span>
                                {isOpen && <span>Email</span>}
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>

            <div className="flex-1 p-4 bg-gray-50">{children}</div>
        </div>
    );
}

export default Layout;
